// extracted by mini-css-extract-plugin
export var button = "_ls-0";
export var donut = "_ls-1";
export var donutFill = "_ls-3";
export var donutTrack = "_ls-2";